var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex flex-wrap flex_gap_5 coords mb-1" },
      [
        _vm._l(_vm.area.coords, function (c, i) {
          return _c("div", { staticClass: "input-group" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.area.coords[i][0],
                    expression: "area.coords[i][0]",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.area.coords[i][0] },
                on: {
                  change: _vm.toUpdate,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.area.coords[i], 0, $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.area.coords[i][1],
                  expression: "area.coords[i][1]",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.area.coords[i][1] },
              on: {
                change: _vm.toUpdate,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.area.coords[i], 1, $event.target.value)
                },
              },
            }),
          ])
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: { click: _vm.addPoint },
          },
          [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "input-group" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.area.fillColor,
              expression: "area.fillColor",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.area.fillColor },
          on: {
            change: _vm.toUpdate,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.area, "fillColor", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.area.strokeColor,
              expression: "area.strokeColor",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.area.strokeColor },
          on: {
            change: _vm.toUpdate,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.area, "strokeColor", $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text small" }, [
        _vm._v("Цвет фона"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text small" }, [
        _vm._v("Цвет контура"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }